import CryptoJS from 'crypto-js';

/**
 * 解密数据
 * @param {string} key - 解密密钥
 * @param {string} encryptedData - 加密后的字符串
 * @returns {string} 解密后的原始数据
 */
export function getDecryptData(key, encryptedData) {
	if (!key || !encryptedData || typeof encryptedData !== 'string') {
		return null;
	}

	try {
		const [ivHex, ciphertextHex] = encryptedData.split(":");
		const iv = CryptoJS.enc.Hex.parse(ivHex);
		const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex);
		const decrypted = CryptoJS.AES.decrypt({ ciphertext }, CryptoJS.enc.Hex.parse(key), {
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
			iv: iv,
		});

		return decrypted.toString(CryptoJS.enc.Utf8);
	} catch (error) {
		console.error("Decryption failed:", error);
		return null;
	}
}